// removed by extract-text-webpack-plugin
module.exports = {"root":"_1SPor","isSummary":"_3CgFg","titleLink":"SAh9N","details":"go1OY","description":"_2sYvA"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/Events/elements/EventJumbo/index.sass
// module id = ./src/modules/Events/elements/EventJumbo/index.sass
// module chunks = 6